<template>
<div class="widthFull center pt-1 pb-1">
  <loading v-if="loadingState" />

  <form class=" black pl-4 pr-4 mb-3 widthFull vaillantCont" @submit.prevent="editUser()">
    <div class="row justify-content-center ">

      <div class="col-md-12 vaillantCont  text-left">
        <div class="group mt-1">

          <label class="form-check-label widthFull Bold blue h5" for="delegate_move_credits">
            <b>Delega intermediario abilitato ad operare nel cassetto fiscale dell'aderente</b> <br /> <small>
              ( con la presente delega autorizzi l'intermediario abilitato ad operare nel tuo cassetto fiscale per accettare il credito dal tuo cliente e cedere il relativo credito al cessionario finale )</small>
          </label>

          <div v-if="getProfile.tipo_azienda != 'Ditta Individuale' && getProfile.tipo_azienda != 'Professionista iscritto ad albi'" class="form-check form-check-inline mt-2">
            <label class="form-check-label " v-on:click="delegate_move_credits = 1">
              <input type="radio" class="form-check-input inline mr-3" v-model="delegate_move_credits" v-validate="'required|included:1,2'" value="1" name="delegate_move_credits" :class="{ 'is-invalid': errors.has('delegate_move_credits') }">
              <b>AUTORIZZO la delega all'intermediario abilitato</b>
              <!-- (escluse Ditte Individuali e Regime Forfettario) -->
            </label>
          </div>
          <div class="form-check form-check-inline">
            <label class="form-check-label Bold pt-3" v-on:click="delegate_move_credits = 2">
              <input type="radio" class="form-check-input inline mr-3" v-model="delegate_move_credits" value="2" name="delegate_move_credits" :class="{ 'is-invalid': errors.has('delegate_move_credits') }">
              NON AUTORIZZO la delega all'intermediario abilitato (*)
              <!-- (incl. Ditte Individuali e Regime Forfettario) -->
            </label>
          </div>
          <br />
          <span class="errorMes Bold" v-show="errors.has('privacy4')">
            Il consenso deve essere accettato oppure rifiutato
          </span>
        </div>

        <h5 v-if="delegate_move_credits == 1" class="pl-md-5 pb-1 ">
            Si richiede di accedere alla Piattaforma di Gestione Crediti Agenzia delle Entrate <b><a href="https://www.agenziaentrate.gov.it/portale/area-riservata" target="_blank" class="black underline"> Fisconline / Entratel</a></b>
            della Società per l’inserimento del Codice Fiscale e del Nome dell'intermediario abilitato per la delega:

            <h5 class="h5 pt-1 Bold ">
              Inserire il seguente Codice Fiscale e Nome dell'intermediario abilitato<br/>
              <template v-if=" brand != 'CHEBONUS' "><b> SLMFMR80D25F205P – Fabio Salamina</b> </template>
              <template v-if=" brand == 'CHEBONUS' "><b> DLFMSM72D02H501O – Massimiliano Delfini</b> </template>
            </h5>

            <h5 class=" mb-5 pb-md-5 borderBottom">
              <a v-if=" brand != 'CHEBONUS' " class="black underline" href="https://storage.googleapis.com/happybonus/Nomina_incarica_o_KPMG_Salamina_Fabio.pdf" target="_blank"><b> Qui </b></a>
              <a v-if=" brand == 'CHEBONUS' " class="black underline" href="https://storage.googleapis.com/chebonus/Nomina_incaricato_KPMG_Delfini_Massimiliano.pdf" target="_blank"><b> Qui </b></a>
               è possibile scaricare il manuale operativo per la nomina dell'intermediario abilitato.
            </h5>

        </h5>

        <p class="pl-md-5 pb-1">
          <b>(*) Se "NON AUTORIZZO", l'operatività all'interno del cassetto fiscale rimarrà a tuo carico o del consulente fiscale/commercialista da te delegato. </b>

        </p>
        <p class="pb-4 pb-1">
          Gli aderenti con forma giuridica Ditte Individuali o Professionisti iscritti all'albo dovranno provvedere autonomamente alla gestione dei crediti nel proprio cassetto fiscale.
        </p>
      </div>

      <!--
    <div v-if="getProfile.delegate_move_credits != delegate_move_credits && delegate_move_credits == '1'" class="col-md-12 center mb-3 pt-0  mb-1">
      <div class="row justify-content-center ">

        <div class="col-md-5  text-center">

          <a class="pointer" target="_blank" href="https://storage.googleapis.com/stage_novatag/ecobonus/2050D0Bs.vt.pdf">
            <h4 class="Bold center pb-0 mb-0"> Scarica modulo </h4>
            <h5 class="mt-0 pt-0">  <img class="img-fluid custSize" src="../../assets/images/pdf.png"> </h5>
          </a>

        </div>
        <div class="col-md-4  text-center">
          <h4 class="Bold center"> Ricarica il file compilato </h4>


          <div class="center"><small>(formato: pdf, jpg, png)</small></div>
          <div class="front-image">

            <input type="file" v-on:change="uploadFile" ref="fileInput" name="invoiceFront" id="invoiceFront" class="fileInput" data-vv-as="File Compilato"
              v-validate="{required:true,size: 10240, ext: ['pdf','jpeg','jpg','png'], mimes: ['application/pdf','image/jpeg', 'image/jpg', 'image/png']}"
              :class="{ 'is-invalid': errors.has('invoiceFront'), valid: !!invoiceFront, helper: !!invoiceFrontBucket }">

            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="niceInputLabel labelFileInput" for="invoiceFront">

              <span v-if="!invoiceFrontName" class="smallText center white" :style="{ backgroundImage: 'url(' + invoiceFrontBucket + ')' }">
                <p v-if="!invoiceFrontName" class="smallText center white mt-3 mb-0 pb-0">Scegli il Contratto quadro*</p>
              </span>

              <span v-else class="smallText center white" :style="{  backgroundImage: 'url(' + invoiceFrontBucket + ')' }">

              </span>

            </label>

            <div v-if="errors.has('invoiceFront')" class="invalid-feedback">
              {{ errors.first('invoiceFront') }}
            </div>

            <div v-if="uploadFrontPercentage" class="progress" id="progFront">
              <div class="progress-bar " id="progress-bar-front" role="progressbar" v-bind:style="{width: uploadFrontPercentage + '%'}" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
                {{ uploadFrontPercentage }} %
              </div>
            </div>

            <p v-if="invoiceFrontName" class="smallText center white mt-3 mb-0 pb-0 fileNameText">{{invoiceFrontName}}</p>

          </div>
        </div>
        </div>

    </div>
  -->

      <div v-if="getProfile.delegate_move_credits != delegate_move_credits " class="col-md-12 center mb-3 pt-0  mb-1">

        <button type="submit" class="btn btn-sm btn-primary">
          Salva
        </button>

      </div>

    </div>
  </form>

</div>
</template>

<script>
import {
  AUTH_REQUEST,
  AUTH_SOCIAL
} from 'actions/auth'
import {
  mapGetters,
  mapState
} from 'vuex'
import axios from 'axios'
import {
  USER_REQUEST,
  USER_SET_DEFAULT_SHIP_DATA
} from 'actions/user'
import Vue from 'vue'

const moment = require('moment')

export default {
  name: 'delegaForm',
  components: {

  },
  props: {

  },
  data() {
    return {
      brand: process.env.BRAND,
      delegate_move_credits: '',
      delegate_move_credits_doc: '',
      loadingState: false,
      invoiceFront: '',
      invoiceFrontName: '',
      invoiceFrontBucket: '',
      uploadFrontPercentage: 0,
      invoiceRear: '',
      invoiceRearName: '',
      invoiceRearBucket: '',
      uploadRearPercentage: 0,
    }

  },
  methods: {
    uploadFile: function(input) {
      var file = input.target.files[0].name
      this.invoiceFrontName = file
      var extension = file.substr((file.lastIndexOf('.') + 1)).toLowerCase()
      var size = input.target.files[0].size
      if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {
        this.invoiceFront = input.target.files[0].name
        var formData = new FormData();
        var _vue = this // << here
        formData.append('fattura0', input.target.files[0]);
        axios.post(process.env.ROOT_API + 'api/uploadImageInvoice',
            formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              },
              onUploadProgress: function(progressEvent) {
                this.uploadFrontPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
              }.bind(this)
            }
          ).then(function(e) {
            var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
            if (regex.test(e.data.fattura)) {
              _vue.uploadFrontPercentage = 0
              _vue.invoiceFrontBucket = e.data.fattura
              _vue.delegate_move_credits_doc = e.data.fattura
            } else {
              _vue.uploadFrontPercentage = 0
              _vue.invoiceFront = ''
              _vue.invoiceFrontBucket = ''
              _vue.UploadError()
              input.target.value = null
            }

          })
          .catch(function() {
            _vue.uploadFrontPercentage = 0
            _vue.invoiceFront = ''
            _vue.invoiceFrontBucket = ''
            _vue.UploadError()
            input.target.value = null

          });
      }

    },
    UploadError() {
      this.$swal({
        type: 'error',
        title: '<strong class="modalText danger">Errore caricamento immagine</strong>',
        html: '',
        confirmButtonText: 'CHIUDI',
        confirmButton: 'closeProductsModal',
        confirmButtonColor: '#15267',
      });
    },
    editUser() {
      console.log(this)
      var _vue = this
      //this.$validator.validateAll(scope).then(function (res) {
      this.$validator.validate().then(function(valid) {

        if (valid) {
          _vue.loadingState = true
          var data = {
            email: _vue.getProfile.email,
            delegate_move_credits: _vue.delegate_move_credits,
            //delegate_move_credits_doc: _vue.delegate_move_credits_doc,
          }

          axios({
              url: process.env.ROOT_API + 'api/editUser',
              method: 'POST',
              data: {
                user: data,
                regType: 'old',
              },
              headers: {
                'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
                'Content-type': 'application/json'
              }
            })
            .then(resp => {
              _vue.$store.dispatch(USER_REQUEST)

              _vue.loadingState = false
              window.location.reload()

            })
            .catch(error => {

              _vue.loadingState = false
              var text = error.response.data.error
              _vue.addClientError(text)

            })

        }

      })

    },
    addClientError(text) {
      this.$swal({
        type: 'error',
        title: '<strong class="modalText danger">Operazione non andata a buon fine.</strong>',
        html: text,
        confirmButtonText: 'CHIUDI',
        confirmButton: 'closeProductsModal',
        confirmButtonColor: '#15267',
      });
    },
    async checkIfExistUser() {
      console.log('11')
      if (this.getProfile) {
        var data = this.getProfile
        console.log('22  ')
        if (data.delegate_move_credits == '0' || data.delegate_move_credits == 0) {
          console.log('33')
          if (data.tipo_azienda == 'Ditta Individuale' || data.tipo_azienda == 'Professionista iscritto ad albi') {
            // ADVISOR CAN'T MOVE CREDIT BY DEFAUL
            this.delegate_move_credits = 2
            this.editUser()
          } else {
            this.delegate_move_credits = 0
          }


        } else {
          this.delegate_move_credits = data.delegate_move_credits
        }

      }
    },
  },
  watch: {
    iban: function(value) {
      this.iban = value.toUpperCase().trim()
      this.iban = this.iban.replace(' ', '')
    },

    async getProfile() {
      await this.checkIfExistUser()
    },
  },
  async created() {
    await this.checkIfExistUser()
  },

  async mounted() {
    await this.checkIfExistUser()
  },
  computed: {
    ...mapGetters(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']),
    ...mapState({
      //response: state => `${state.status.response.data}`,
    }),

  },
}
</script>

<style lang="scss" scoped>
$phone: 667px;
$tablet: 1024px;
$desktop: 1324px;
$lgscreen: 1524px;

.fileNameText {
    position: absolute;
    bottom: -37px;
    font-size: 17px;
    width: 100%;
    text-align: center;
    color: #0e3d8b!important;
    z-index: 12313;
    white-space: nowrap;
    word-wrap: break-word;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.custSize {
    max-width: 100px;
}

.borderTop {
    border-top: 3px solid #003d13;
    padding-top: 15px;
}

.shopIcon {
    width: 75px;
}

.bigTitle {
    font-size: 47px;
    color: #003d13;

    @media screen and (max-width: $phone) {
        font-size: 27px;
    }

}

.hideFileUpload {
    position: absolute;
    width: 100%;
    height: 110%;
    background: #000000;
    opacity: 0.4;
    top: -18px;
    left: 0;
    filter: blur(24px);
    z-index: 10000;
}

h5 {

    @media screen and (max-width: $phone) {
        font-size: 14px;
    }

}
.corporateImg {
    max-height: 153px;
}
.backImageInvoice {
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    text-align: center;
    > img {
        max-height: 477px;
        margin: 0 auto;
        cursor: pointer;
    }
}

.zoomImage {
    position: absolute;
    left: 48%;
    top: 230px;
    cursor: pointer;
}

.vcenter {
    align-items: center;
    align-self: center;
    vertical-align: middle;
    display: inherit;
}

.front-image {

    position: relative;
    margin: 0 auto;
    display: block;
    height: 147px;
    text-align: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-item-align: center;
    align-self: center;
    width: 191px;
    margin-bottom: 17px;

    @media screen and (max-width: $tablet) {
        margin-top: 15px!important;
    }

    > .fileInputLabel {
        display: none;
    }

    > .invalid-feedback {
        display: block;
        position: absolute;
        bottom: 15px;
        font-weight: 800;
    }

    > input {
        position: absolute;
        filter: alpha(opacity=0);
        opacity: 0;
        left: 5px;
        width: 100%;
        height: 200px;
        z-index: 10;
        top: -20px;
    }

    > label {
        /*display: none;*/

        width: 100%;
        margin: 0 auto;
        text-align: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-item-align: center;
        align-self: center;
        position: relative;
        padding: 0!important !important;
        left: 0;

        > span {
            background-color: transparent;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            border: none;
            width: 192px;
            margin-top: 19px !important;
            display: block;
            height: 155px;
            margin: 0 auto;
            cursor: pointer;
            word-break: break-all;
            padding: 5px;
            color: white;
            border-radius: 7px;
            overflow-wrap: break-word;
            white-space: normal;
            line-height: 29px;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            align-self: center;
            vertical-align: middle;
            margin: auto;
            display: inline-grid;
            background-size: cover;
            background-position: center;

            &:before {
                content: "+";
                display: block;
                clear: both;
                text-align: center;
                height: 141px;
                width: 179px;
                border-radius: 7px;
                padding-top: 51px;
                font-size: 51px;
                font-weight: 600;
                color: #00917e;
                border: 3px solid #00917e;
            }

            @media screen and (max-width: $phone) {
                margin: 0 auto!important !important;
                float: none;
            }
            @media screen and (min-width: $phone) and (max-width: $tablet) {
                margin: 0 auto!important !important;
                float: none;
            }

        }

        &:after {
            content: "";
            display: block;

            clear: both;
            text-align: center;
            width: 237px;
            font-size: 10px;
            text-decoration: underline;
            color: black;

            /*
      display: block;
clear: both;
text-align: center;
height: 188px;
width: 188px;
border-radius: 7px;
font-size: 10px;
text-decoration: underline;
color: black;
border: 3px solid #0e3d8b;*/

            @media screen and (max-width: $phone) {
                margin: 0 auto!important !important;
                float: none;
            }
            @media screen and (min-width: $phone) and (max-width: $tablet) {
                margin: 0 auto!important !important;
                float: none;
            }

        }

        @media screen and (max-width: $phone) {
            width: 100%!important;
            float: none!important;
            text-align: center!important;
            margin: 0 auto!important !important;
        }
        @media screen and (min-width: $phone) and (max-width: $tablet) {
            width: 100%!important;
            float: none!important;
            text-align: center!important;
            margin: 0 auto!important !important;
        }

    }

}

.center-container {
    display: flex;
    align-items: center;
    flex-direction: column;
}
</style>


<style lang="css" scoped>
.sweetText {
  font-size: 26px;
}
	.imageIcons {
		vertical-align: bottom!important;
		width: 50px;
	}


  .hSize {
    font-size: 33px!important;
}

	.howPlayTextCont[data-v-54f59cc7] {
		max-width: 333px;
		text-align: left;
		margin: 0 auto;
		line-height: 27px;
		padding-left: 61px;
	}


	/* new PRICE */

	.swal2-popup .swal2-title, #swal2-content {
		color: #fffbde!important;
		display: block!important;
	}

	.replaceButton{
		max-width: 40px;
	}

	.inputHelper{
    margin-top: -32px;
    color: #0e3d8b;
    font-size: 16px;
    left: 0;
	}

	.priceVal, .priceCent{
		width: calc(50% - 1.5vw - 7.5px);
		display: inline-table;
	}

	.pseudoEuro {
		position: absolute;
		top: 6px;

	}
	.pseudoCent {
		position: absolute;
		top: 6px;
		right:0;

	}

	.group input:focus + .pseudoEuro {
		display:block;
	}

	.group .valid + .pseudoEuro{
		display:block;
	}

	.group input:focus + .pseudoCent {
		display:block;
	}

	.group .valid + .pseudoCent{
		display:block;
	}

	.euroInput{
		position: relative;
		width:200%;
		z-index: 4;
	}

	.euroInput::before{
		content: 'Euro';
	}

	.euroInput:focus, .euroInput.valid{
		width:100%;
	}

	.euroInput:focus::before, .euroInput.valid::before{
		content: 'Euro';
		color: white;
		position: absolute;
	}


	.table{
		display: table;
	}

	.newPriceLabel{
		z-index: 5;
		background: white;
		margin-left: -5px;
		padding-left: 5px;
		overflow: initial;
		min-width: calc(200% + 17px);
	}


	/*  ------------ */

	.image-margin0{
		margin: 0!important;
	}



	.helper{
		color: #0e3d8b;
		font-size: 23px;
		font-family: Oswald-Medium;
	}

	.greyDesc2{
		font-size: 1.1vw;
		color: #fffbde;
	}

	.redDesc{
		font-size: 1.1vw;
		text-decoration: underline;
		cursor: pointer;
	}

	.uploadDone {
		position: absolute;
		top: 10px;
		right: 0;
		color: #a1614f;
	}

	.helperUnderline {

	}

	.labelFileInput{
		top: -20px!important;
		font-size: 22px;
		color: #000000;
	}

	.fileInput{
		position: absolute;
		z-index: 1;
		width: 100%;
		height: 100%;
		padding: 0;
		top: 17px;
		border-bottom: none;
		color: #000000;
	}

	.fileInputLabel{
		z-index: 3;
		white-space: nowrap;
		overflow: hidden;
		padding-right: 20px;
		text-overflow: ellipsis;
		color: #fffbde;
	}

	.removeProduct{
		position: absolute;
		right: 21px;
		margin: 0px!important;
		top: 48px;
		color: #e7201d;
	}

	.typeDisabled{
		color: #676767;
		cursor: pointer;
	}

	.typeSelected {
		color: #fffbde!important;
		cursor: pointer;
	}



	@media (min-width: 20px) and (max-width: 767px) {

    .inputHelper {
      margin-top: -12px;
      color: #0e3d8b;
      font-size: 16px;
      left: 0;
    }

    .hSize {
      font-size: 19px!important;
    }
    .sweetText {
      font-size: 19px;
    }
    .removeProduct{
    position: absolute;
    right: 21px;
    margin: 0px!important;
    top: 26px;
    color: #e7201d;
}

		.greyDesc2, .redDesc{
			font-size: 3.1vw;
		}

		.fluid {
			max-width: 107px;
		}

		.mobTQ{
			font-size: 23px;
		}

		.smMob{
			font-size: 1rem;
		}

		.howPlayTextCont[data-v-54f59cc7][data-v-54f59cc7] {
			max-width: 350px;
			text-align: left;
			margin: 0 auto;
			line-height: 27px;
			padding-left: 43px;
			font-size: 17px;
		}


		.helper {
			color: #0e3d8b;
			font-size: 18px;
			font-family: Oswald-Medium;
		}
		.imageIcons {
			vertical-align: bottom!important;
			width: 39px;
		}
		.fileInput {

			top: 8px!important;

		}


	}


	@media (min-width: 768px) and (max-width: 1205px) {

		.disabledDatesMessage{
			 top: -250%;
		}

	}






</style>



// WEBPACK FOOTER //
// src/components/flowSettings/delegaForm.vue